import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { EntryTextField } from 'components/common/form';
import { translateApiValue } from 'utils/translateApiValue';

import { ColumnBaseProps } from '../types';

const NameColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  const { t } = useTranslation();

  if (record.formField.custom) {
    return (
      <EntryTextField
        placeholder={t('common.enterName')}
        model={record.formField.nameModel}
      />
    );
  }

  return (
    <Typography.Text>
      {translateApiValue(record.formField.fieldData.name)}
    </Typography.Text>
  );
};

export default observer(NameColumn);
